import { Modal } from "components/Modal";

interface PhotoSourcePickerProps {
  show: boolean;
  onClose: () => void;
  onCamera: () => void;
  onGallery: () => void;
}

export function PhotoSourcePicker({
  show,
  onClose,
  onCamera,
  onGallery,
}: PhotoSourcePickerProps) {
  return (
    <Modal show={show} onClose={onClose}>
      <div className="space-y-3">
        <button
          onClick={onCamera}
          className="w-full py-3 px-4 bg-3461fd hover:bg-3461fd/90 text-white rounded-xl font-medium transition-colors"
        >
          Take Photo
        </button>
        <button
          onClick={onGallery}
          className="w-full py-3 px-4 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-xl font-medium transition-colors"
        >
          Choose from Gallery
        </button>
        <button
          onClick={onClose}
          className="w-full text-sm text-gray-500 hover:text-gray-700 transition-colors py-1"
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
}
